import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-clients-grid',
  templateUrl: './clients-grid.component.html',
  styleUrls: ['./clients-grid.component.css']
})
export class ClientsGridComponent implements OnInit {
  title="Clients";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/view/clients/clients-grid/clients-grid.component.ts